import { CssBaseline } from "@mui/material";
import * as React from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";

import Loading from "../components/Loading";
import {
  ACCESS_REQUESTS_ROUTE,
  API_DOCS_ROUTE,
  ASSISTANT_ROUTE,
  DATA_EXPLORER_ROUTE,
  JOBS_OVERVIEW_ROUTE,
  JOBS_ROUTE,
  NOTEBOOKS_ROUTE,
  PERMISSIONS_ROUTE,
} from "../helpers/constants";
import { usePageViewTracking } from "../helpers/tracking";
import AccessRequests from "../modules/app/access-requests/AccessRequests";
import AppLayout from "../modules/app/components/AppLayout/AppLayout";
import { GetStartedProvider } from "../modules/app/components/GetStarted/GetStartedContext";
import Permissions from "../modules/app/permissions/Permissions";
import Assistant from "../modules/assistant/Assistant";
import Dashboard from "../modules/dashboard/Dashboard";
import DataExplorer from "../modules/data-explorer/DataExplorer";
import Jobs from "../modules/jobs/Jobs";
import Notebooks from "../modules/notebooks/Notebooks";
import Overview from "../modules/overview/Overview";
import NotFound from "../pages/NotFound";

const ApiDocs = React.lazy(() => import("../pages/ApiDocs"));

function AppRouter() {
  usePageViewTracking();
  const location = useLocation();
  const state = location.state;

  return (
    <React.StrictMode>
      <GetStartedProvider>
        <CssBaseline />
        <AppLayout>
          <React.Suspense fallback={<Loading />}>
            {state && "notFound" in state ? (
              <NotFound />
            ) : (
              <Routes>
                <Route path="*" element={<Dashboard />} />
                <Route
                  path="/apps/dashboard"
                  element={<Navigate to="/" replace />}
                />
                <Route path={`${JOBS_ROUTE}/*`} element={<Jobs />} />
                <Route
                  path={`${JOBS_OVERVIEW_ROUTE}/*`}
                  element={<Overview />}
                />
                <Route
                  path={`${DATA_EXPLORER_ROUTE}/*`}
                  element={<DataExplorer />}
                />
                <Route path={`${NOTEBOOKS_ROUTE}/*`} element={<Notebooks />} />
                <Route path={API_DOCS_ROUTE} element={<ApiDocs />} />
                <Route path={`${ASSISTANT_ROUTE}/*`} element={<Assistant />} />
                <Route
                  path={`${PERMISSIONS_ROUTE}/*`}
                  element={<Permissions />}
                />
                <Route
                  path={`${ACCESS_REQUESTS_ROUTE}/*`}
                  element={<AccessRequests />}
                />
                <Route element={<NotFound />} />
              </Routes>
            )}
          </React.Suspense>
        </AppLayout>
      </GetStartedProvider>
    </React.StrictMode>
  );
}

export default AppRouter;
